import config from "../../config";
import { GET_WALLET_HISTORY } from "./types";

export const GetWalletHistoryAction = () => async (dispatch, getState) => {
    const res = await config.getApi(
        config.services.walletHistory(),
        config.bearerHeaders(getState().auth.token)
    );
    if (res) {
        dispatch({ type: GET_WALLET_HISTORY, payload: res.response.data });
    }
};
